import { useState, useEffect } from "react";

const KEY = "lmp_geo";

export function useGeo() {
  const [geo, setGeo] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; }
  });

  const request = () => {
    if (!navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const g = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        localStorage.setItem(KEY, JSON.stringify(g));
        setGeo(g);
      },
      () => {
        // fallback: Abidjan center
        const g = { lat: 5.345, lng: -4.0, fallback: true };
        localStorage.setItem(KEY, JSON.stringify(g));
        setGeo(g);
      }
    );
  };

  useEffect(() => { if (!geo) request(); }, []); // eslint-disable-line
  return { geo, request };
}
